import { AiFillDelete } from "react-icons/ai"; 
import { RiDeleteBinLine } from "react-icons/ri"; 
import { RiAttachment2 } from "react-icons/ri";
import { MdOutlineNoteAdd } from "react-icons/md"; 
import { MdOutlineAddBox } from "react-icons/md"; 
import { RiFolderAddLine } from "react-icons/ri"; 
import { RiPlayListAddLine } from "react-icons/ri"; 
import { BiEditAlt } from "react-icons/bi"; 
import { BiCamera } from "react-icons/bi";
import { AiFillLike ,AiFillDislike} from "react-icons/ai"; 
import { AiTwotoneLike } from "react-icons/ai"; 
import { SlDislike ,SlLike} from "react-icons/sl"; 
import { MdDelete } from "react-icons/md";

import { ImUsers } from "react-icons/im"; 
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { compressImages } from '../../utils/imageUtils';
import MessageImages from '../../components/MessageImages';


const API_URL = process.env.REACT_APP_API_URL;
const MessageBoardPosting = () => {
  const [showPostModal, setShowPostModal] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [myPosts, setMyPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [expandedPosts, setExpandedPosts] = useState(new Set());
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // Image upload state
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]);
  const [isCompressingImages, setIsCompressingImages] = useState(false);

  // Emoji list for quick selection
  const emojis = ['😊', '😀','😙','😚','😫','🤐','😴','🤣','😂','😔','😷','😄', '😍', '🥰', '😘', '😉', '😎', '🤗', '👍', '❤️', '💕', '💖', '💝', '🌹', '🌸', '✨', '🎉', '🎊', '🎈', '🎁'];

  useEffect(() => {
    fetchMyPosts();
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchMyPosts = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/board/my-posts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMyPosts(response.data);
    } catch (error) {
      console.error('Error fetching my posts:', error);
      alert('投稿の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  const addEmoji = (emoji) => {
    setContent(prev => prev + emoji);
    setShowEmojiPicker(false);
  };

  const handleImageSelect = async (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/') && !file.type.startsWith('video/'));
    
    if (imageFiles.length === 0) {
      alert('画像ファイルを選択してください（動画ファイルは除く）');
      return;
    }

    if (selectedImages.length + imageFiles.length > 10) {
      alert('画像は最大10枚まで選択できます');
      return;
    }

    setIsCompressingImages(true);
    try {
      const compressedImages = await compressImages(imageFiles);
      setSelectedImages(prev => [...prev, ...compressedImages]);
      setImagePreviewUrls(prev => [...prev, ...compressedImages]);
    } catch (error) {
      console.error('Error compressing images:', error);
      alert('画像の圧縮に失敗しました');
    } finally {
      setIsCompressingImages(false);
    }
  };

  const removeImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviewUrls(prev => prev.filter((_, i) => i !== index));
  };

  const handleCreatePost = async () => {
    if (!title.trim() || (!content.trim() && selectedImages.length === 0)) {
      alert('タイトルと内容または画像を入力してください');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/api/board`, {
        title: title.trim(),
        content: content.trim(),
        images: selectedImages
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('投稿が完了しました！');
      setShowPostModal(false);
      setTitle('');
      setContent('');
      setSelectedImages([]);
      setImagePreviewUrls([]);
      fetchMyPosts(); // Refresh the list
    } catch (error) {
      console.error('Error creating post:', error);
      alert(error.response?.data?.message || '投稿の作成に失敗しました');
    }
  };

  const handleDeletePost = async (postId) => {
    if (!window.confirm('この投稿を削除しますか？この操作は取り消せません。')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/api/board/${postId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('投稿が削除されました');
      fetchMyPosts(); // Refresh the list
    } catch (error) {
      console.error('Error deleting post:', error);
      alert(error.response?.data?.message || '投稿の削除に失敗しました');
    }
  };

  const togglePostExpansion = (postId) => {
    setExpandedPosts(prev => {
      const newSet = new Set(prev);
      if (newSet.has(postId)) {
        newSet.delete(postId);
      } else {
        newSet.add(postId);
      }
      return newSet;
    });
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <p>読み込み中...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: isMobile ? '10px' : '0px' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '15px' : '0px'
      }}>
        <h2 style={{ 
          color: '#333',
          fontSize: isMobile ? '20px' : '24px',
          margin: '0'
        }}>掲示板投稿</h2>
        <button
          onClick={() => setShowPostModal(true)}
          style={{
            backgroundColor: '#ff6b35',
            color: 'white',
            border: 'none',
            padding: isMobile ? '12px 20px' : '8px 24px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: isMobile ? '14px' : '16px',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <MdOutlineNoteAdd style={{fontSize: isMobile ? '18px' : '20px', marginBottom:'-3px'}}/>  新規投稿
        </button>
      </div>

      {myPosts.length === 0 ? (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '40px', 
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '18px', color: '#666' }}>まだ投稿がありません</p>
          <p style={{ color: '#999', marginTop: '10px' }}>「新規投稿」ボタンから投稿を作成してください</p>
        </div>
      ) : (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px'
        }}>
          <h3 style={{ marginBottom: '20px' }}>私の投稿 ({myPosts.length}件)</h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {myPosts.map((post) => (
              <div key={post._id} style={{ 
                border: '1px solid #ddd', 
                borderRadius: '8px', 
                padding: '20px',
                position: 'relative'
              }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  gap: isMobile ? '10px' : '15px', 
                  marginBottom: '15px',
                  flexDirection: isMobile ? 'column' : 'row'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '10px' : '15px' }}>
                    {post.userID?.photoLink ? (
                      <img 
                        src={post.userID.photoLink.photodatas || post.userID.photoLink} 
                        alt="Profile" 
                        style={{ 
                          width: isMobile ? '40px' : '50px', 
                          height: isMobile ? '40px' : '50px', 
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }} 
                      />
                    ) : (
                      <div style={{ 
                        width: isMobile ? '40px' : '50px', 
                        height: isMobile ? '40px' : '50px', 
                        borderRadius: '50%', 
                        backgroundColor: '#ddd',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: isMobile ? '10px' : '12px'
                      }}>
                        なし
                      </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h4 style={{ 
                        margin: '0 0 5px 0',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal',
                        lineHeight: '1.4',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: '600',
                        color: '#333'
                      }}>
                        {post.title}
                      </h4>
                      <p style={{ 
                        margin: '0', 
                        color: '#666', 
                        fontSize: isMobile ? '12px' : '14px' 
                      }}>
                        {post.userID?.name || 'Unknown'} • {new Date(post.created_at).toLocaleString('ja-JP')}
                      </p>
                    </div>
                  </div>
                </div>
                
                <div style={{
                  lineHeight: '1.6', 
                  wordBreak: 'break-word', 
                  whiteSpace: 'pre-wrap', 
                  overflowWrap: 'break-word',
                  maxHeight: expandedPosts.has(post._id) ? 'none' : '4.8em', // 3 lines
                  overflow: expandedPosts.has(post._id) ? 'visible' : 'hidden',
                  position: 'relative',
                  fontSize: isMobile ? '13px' : '14px',
                  padding: isMobile ? '10px 0' : '15px 0'
                }}>
                  {post.content}
                  {!expandedPosts.has(post._id) && post.content && post.content.length > 150 && (
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      background: 'linear-gradient(transparent, white)',
                      width: '100px',
                      height: '1.6em'
                    }}></div>
                  )}
                </div>
                {post.images && post.images.length > 0 && (
                  <div style={{ marginTop: '10px' }}>
                    <MessageImages images={post.images} />
                  </div>
                )}
                
                {post.content && post.content.length > 150 && (
                  <div 
                    onClick={() => togglePostExpansion(post._id)} 
                    style={{ 
                      color: '#007bff', 
                      cursor: 'pointer', 
                      fontSize: '14px',
                      marginTop: '10px'
                    }}
                  >
                    {expandedPosts.has(post._id) ? '▲ 折りたたむ' : '▼ 全文を表示'}
                  </div>
                )}
                
                {/* Reader count in bottom right */}
                <div style={{
                  position: 'absolute',
                  bottom: '10px',
                  right: '20px',
                  color: '#666',
                  fontSize: '12px'
                }}>
                  <ImUsers style={{fontSize:'18px', paddingTop:'10px'}} /> {post.readerCount || 0} 読者
                </div>

                {/* Like/Dislike counts in bottom left */}
                <div style={{
                  position: 'absolute',
                  bottom: '10px',
                  right: '100px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  color: '#666',
                  fontSize: '14px'
                }}>
                  <span><AiFillLike style={{color:"orange", fontSize:"18px"}}/> {post.likes ? post.likes.length : 0}</span>
                  <span><AiFillDislike style={{color:"orange", fontSize:"18px"}} /> {post.dislikes ? post.dislikes.length : 0}</span>
                </div>

                {/* Delete button in top right */}
                <div style={{
                  position: 'absolute',
                  top: '3px',
                  right: '5px'
                }}>
                  <div
                    onClick={() => handleDeletePost(post._id)}
                  //   style={{
                  //     backgroundColor: '#dc3545',
                  //     color: 'white',
                  //     border: 'none',
                  //     borderRadius: '50%',
                  //     width: '32px',
                  //     height: '32px',
                  //     cursor: 'pointer',
                  //     display: 'flex',
                  //     alignItems: 'center',
                  //     justifyContent: 'center',
                  //     fontSize: '16px'
                  //   }}
                  //   title="投稿を削除"
                  >
                    <AiFillDelete style={{color: '#dc3545',}}/>
                  </div>
                </div>

                {/* Like/Dislike counts in bottom left */}
                {/* <div style={{
                  position: 'absolute',
                  bottom: '15px',
                  right: '100px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  color: '#666',
                  fontSize: '14px'
                }}>
                  <span><SlLike />{post.likes ? post.likes.length : 0}</span>
                  <span><SlDislike /> {post.dislikes ? post.dislikes.length : 0}</span>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Create Post Modal */}
      {showPostModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: isMobile ? '20px' : '30px',
            borderRadius: '10px',
            width: isMobile ? '95%' : '600px',
            maxWidth: isMobile ? '95vw' : '600px',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3>新規投稿</h3>
              <button
                onClick={() => {
                  setShowPostModal(false);
                  setTitle('');
                  setContent('');
                  setSelectedImages([]);
                  setImagePreviewUrls([]);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                閉じる
              </button>
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>タイトル:</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={{
                  width: '95%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  fontSize: '16px'
                }}
                placeholder="投稿のタイトルを入力してください..."
                maxLength={100}
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>内容:</label>
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                style={{
                  width: '96%',
                  height: '200px',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  resize: 'vertical',
                  fontSize: '14px'
                }}
                placeholder="投稿の内容を入力してください..."
              />
            </div>
            
            {/* Image Upload + Emoji controls (match ProfileSearch layout) */}
            <div style={{}}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <label
                    style={{
                      border: '1px solid #3498db',
                      color: 'black',
                      padding: '8px 10px 0px 10px ',
                      borderRadius: '5px',
                      cursor: (isCompressingImages || selectedImages.length >= 10) ? 'not-allowed' : 'pointer',
                      fontSize: '20px',
                      display: 'inline-block',
                      opacity: (isCompressingImages || selectedImages.length >= 10) ? 0.6 : 1
                    }}
                  >
                    <RiAttachment2 />
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageSelect}
                      disabled={isCompressingImages || selectedImages.length >= 10}
                      style={{ display: 'none' }}
                    />
                  </label>
                  <label
                    style={{
                      border: '1px solid #27ae60',
                      color: 'black',
                      padding: '8px 10px 0px 10px ',
                      borderRadius: '5px',
                      cursor: (isCompressingImages || selectedImages.length >= 10) ? 'not-allowed' : 'pointer',
                      fontSize: '20px',
                      display: 'inline-block',
                      opacity: (isCompressingImages || selectedImages.length >= 10) ? 0.6 : 1
                    }}
                  >
                    <BiCamera />
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      onChange={handleImageSelect}
                      disabled={isCompressingImages || selectedImages.length >= 10}
                      style={{ display: 'none' }}
                    />
                  </label>
                </div>
                <div>
                  <button
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    style={{
                      backgroundColor: '#ff9800',
                      color: 'white',
                      border: 'none',
                      padding: '8px 8px',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      marginRight: '10px'
                    }}
                  >
                    😊 絵文字
                  </button>
                </div>
              </div>

              {showEmojiPicker && (
                <div style={{
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  padding: '10px',
                  backgroundColor: '#f9f9f9',
                  marginTop: '10px'
                }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(15, 1fr)', gap: '2px' }}>
                    {emojis.map((emoji, index) => (
                      <button
                        key={index}
                        onClick={() => addEmoji(emoji)}
                        style={{
                          background: 'none',
                          border: 'none',
                          fontSize: '25px',
                          cursor: 'pointer',
                          padding: '1px'
                        }}
                      >
                        {emoji}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              {isCompressingImages && (
                <div style={{ color: '#666', fontSize: '12px', marginBottom: '10px' }}>
                  画像を圧縮中...
                </div>
              )}
              {imagePreviewUrls.length > 0 && (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                  gap: '10px',
                  marginTop: '10px'
                }}>
                  {imagePreviewUrls.map((url, index) => (
                    <div key={index} style={{ position: 'relative' }}>
                      <img
                        src={url}
                        alt={`Preview ${index + 1}`}
                        style={{
                          width: '100%',
                          height: '100px',
                          objectFit: 'cover',
                          borderRadius: '5px',
                          border: '1px solid #ddd'
                        }}
                      />
                      <button
                        onClick={() => removeImage(index)}
                        style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          backgroundColor: '#e74c3c',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowPostModal(false);
                  setTitle('');
                  setContent('');
                  setSelectedImages([]);
                  setImagePreviewUrls([]);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                キャンセル
              </button>
              <button
                onClick={handleCreatePost}
                disabled={!title.trim() || (!content.trim() && selectedImages.length === 0)}
                style={{
                  backgroundColor: (!title.trim() || (!content.trim() && selectedImages.length === 0)) ? '#95a5a6' : '#4CAF50',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                投稿
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageBoardPosting; 